// Dashboard servisi - Dashboard verilerini yönetir
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Token'ı otomatik ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Dashboard servis fonksiyonları
export const dashboardService = {
  // Dashboard istatistiklerini al
  async getStats() {
    try {
      const response = await api.get('/dashboard/stats');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Yaklaşan toplantıları al
  async getUpcomingMeetings() {
    try {
      const response = await api.get('/dashboard/upcoming-meetings');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Takvim için tüm toplantıları al (geçmiş + gelecek)
  async getAllMeetings() {
    try {
      const response = await api.get('/dashboard/meetings');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tüm kullanıcıların toplantılarını al
  async getAllUsersMeetings() {
    try {
      const response = await api.get('/dashboard/all-meetings');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Belirli kullanıcının toplantılarını al
  async getUserMeetings(userId, filterType = 'created') {
    try {
      const response = await api.get(`/dashboard/user-meetings/${userId}?filterType=${filterType}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Kullanıcıları al
  async getUsers() {
    try {
      const response = await api.get('/users');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Çoklu kullanıcının toplantılarını al
  async getMultipleUsersMeetings(userIds, filterType = 'created') {
    try {
      const response = await api.post('/dashboard/multiple-users-meetings', { userIds, filterType });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Son aktiviteleri al
  async getRecentActivities() {
    try {
      const response = await api.get('/dashboard/recent-activities');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Müşteri grafik verilerini al
  async getCustomerChart() {
    try {
      const response = await api.get('/dashboard/customer-chart');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Proje durum grafik verilerini al
  async getProjectStatusChart() {
    try {
      const response = await api.get('/dashboard/project-status-chart');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Kullanıcıya özel detaylı istatistikleri al
  async getUserStats() {
    try {
      const response = await api.get('/dashboard/user-stats');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Bekleyen teklifleri al
  async getPendingOffers() {
    try {
      const response = await api.get('/dashboard/pending-offers');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
